// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconCustomTrend = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '24',
      height: '24',
      viewBox: '0 0 12 15',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M4.62781 3.72314L7.21808 1.13288C7.26868 1.08228 7.32619 1.03688 7.39523 1.01803C7.62883 0.954242 7.96115 1.03106 7.96115 1.72282C7.96115 2.41472 7.96115 4.81879 7.96115 6.39035C7.96115 6.75854 8.25962 7.05632 8.62781 7.05632L10.6278 7.05632C10.85 7.05632 11.1611 7.25632 10.6278 8.05632L5.29448 14.0563C5.08916 14.3643 4.58033 14.7861 4.08346 14.2175C3.99685 14.1184 3.96115 13.9879 3.96115 13.8563C3.96115 13.1601 3.96115 10.9354 3.96115 9.38918C3.96115 9.02099 3.66267 8.72298 3.29448 8.72298L1.57062 8.72298C1.39381 8.72298 1.21645 8.65659 1.1295 8.50263C0.970713 8.22146 0.891277 7.79285 1.29448 7.38965C1.82765 6.85632 2.84983 5.61187 3.29427 5.05632',
      stroke: 'currentColor',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    }),
  );

export { IconCustomTrend };
